'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Box = Box;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _asBlock = require('./as-block');

var _asBlock2 = _interopRequireDefault(_asBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Box component.  The lowest-level building component for other layout
 * components.  Use this to apply style properties to a wrapping container.
 *
 * @example
 * <Box margin={2} padding={3}>
 *      <MyComponent {...}  />
 * </Box>
 */
function Box(props) {
    var _props$is = props.is,
        is = _props$is === undefined ? 'div' : _props$is,
        rest = _objectWithoutProperties(props, ['is']);

    return _react2['default'].createElement(is, rest);
}

Box.propTypes = {

    /**
     * Can be either a string representing a React element ('div', 'span', etc)
     * or another component.
     */
    is: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.func])
};

exports['default'] = (0, _asBlock2['default'])(Box);


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/box.jsx
 ** module id = 303
 ** module chunks = 0 1
 **/